import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import TableRow from '@material-ui/core/TableRow';
import TableCell from 'components/tables/tableCell';
import Checkbox from 'components/forms/Checkbox';
import MessageOutlineIcon from 'mdi-react/MessageOutlineIcon';
import { getFullName } from 'utils/contact';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import ReplyStatusBadge from 'components/Inbox/InboxList/ReplyStatusBadge';
import EmailValidationStatus from 'components/EmailValidationStatus';
import { Can, AbilityContext } from 'utils/permissions';
import MessagesPopover from '../../MessagesPopover';
import ActionsPopover from './ActionsPopover';
import { CONTACT_STATUSES } from '../../../../constants/contact';
import ErrorPopover from './ErrorPopover';

class ContactRow extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleDotsClick = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  handleDotsClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ anchorEl: null });
  }

  renderCurrentSequenceStatus = (contact) => {
    const { fieldsToShow } = this.props;
    const deliveryStatus = contact.delivery_status;
    const popoverErrorId = `popover-validationError-${contact.id}`;
    const replyStatus = contact.inbox_category;
    return (
      <React.Fragment>
        {fieldsToShow.deliveryStatus.show && (
          <TableCell className="material-table__row__cell">
            {!isEmpty(deliveryStatus) &&
              <>
                <ReplyStatusBadge status={deliveryStatus} id={popoverErrorId} />
                {deliveryStatus === CONTACT_STATUSES.variableError &&
                  <ErrorPopover targetId={popoverErrorId} contact={contact} />}
              </>
            }
          </TableCell>
        )}
        {fieldsToShow.inboxCategory.show && (
          <TableCell className="material-table__row__cell">
            {!isEmpty(contact.replies) &&
              <ReplyStatusBadge status={replyStatus} autoCategorized={!isEmpty(contact.auto_categorized_date)} />}
          </TableCell>
        )}
      </React.Fragment>
    );
  }

  renderAllReplies = (contact) => {
    const { parentComponentId } = this.props;
    const popoversReplyId = `popover-replies-${parentComponentId}-${contact.id}`;
    return (
      <TableCell className="material-table__row__cell rectangle-cell">
        {contact.replies.length > 0 && (
          <React.Fragment>
            <div
              className="rectangle-cell__item"
              role="button"
              id={popoversReplyId}
            >
              <MessageOutlineIcon />
              ({contact.replies.length})
            </div>
            <MessagesPopover uuid={parentComponentId} seqContact={contact} />
          </React.Fragment>
        )}
      </TableCell>
    );
  }

  renderContactErrors = (contact) => {
    const { parentComponentId } = this.props;
    const popoversErrorId = `popover-errors--${parentComponentId}-${contact.id}`;
    return (
      <React.Fragment>
        <div
          role="button"
          className="rectangle-cell__item"
          id={popoversErrorId}
        >
          <AlertOutlineIcon />
          ({contact.errors.length})
        </div>
        <ErrorPopover targetId={popoversErrorId} contact={contact} />
      </React.Fragment>
    );
  };

  renderSteps = contact => (
    <TableCell>
      <div className="pill-steps">
        <span>{contact.current_step}</span>
        <span>{contact.total_steps}</span>
      </div>
    </TableCell>
  );

  renderPopoverActions = (contact) => {
    const { anchorEl } = this.state;
    const { parentComponentId, toggleModal } = this.props;
    const popoversActionId = `popover-actions-${parentComponentId}-${contact.id}`;
    return (
      <React.Fragment>
        <div
          id={popoversActionId}
          onClick={this.handleDotsClick}
          className="more-actions"
          role="button"
          tabIndex="-1"
          onKeyDown={() => { }}
        >
          <MoreHorizIcon />
        </div>
        <ActionsPopover
          anchorEl={anchorEl}
          toggleModal={toggleModal}
          seqContact={contact}
          handleClose={this.handleDotsClose}
        />
      </React.Fragment>
    );
  }
  render() {
    const {
      seqContact,
      isSelected,
      showErrors,
      showContactReplyForCurrentSequence,
      fieldsToShow,
    } = this.props;

    return (
      <TableRow
        className="material-table__row"
        role="checkbox"
        onClick={this.props.toggleContactEditModal}
        // prevent text selection during shift + click
        onMouseDown={event => event.shiftKey && event.preventDefault()}
        aria-checked={isSelected}
        tabIndex={-1}
        key={seqContact.id}
        selected={isSelected}
      >
        <TableCell className="material-table__row__cell position-relative flex flex-col justify-center text-sm whitespace-nowrap">
          <Can I="edit" a="Sequence Contact">
            <Checkbox
              checked={isSelected}
              onClick={event => this.props.handleSelectClick(event, seqContact.id)}
              style={{ position: 'absolute', top: 8, left: 8 }}
            />
          </Can>
          {getFullName(seqContact)}
          {this.context.can('see', 'Contact Email') && (
            <span className="block text-xs text-gray-500">
              <EmailValidationStatus className="mr-1" status={seqContact.email_validation_status} />
              {seqContact.email}
            </span>
          )}
        </TableCell>
        <TableCell className="material-table__row__cell">{seqContact.outlet.name}</TableCell>
        {fieldsToShow.stepSent.show && this.renderSteps(seqContact)}

        {showContactReplyForCurrentSequence ?
          this.renderCurrentSequenceStatus(seqContact) : this.renderAllReplies(seqContact)}
        {showErrors &&
          <TableCell className="material-table__row__cell rectangle-cell">
            {seqContact.errors.length > 0 ? this.renderContactErrors(seqContact)
              : <div className="rectangle-cell--always-space" />}
          </TableCell>}
        {fieldsToShow.delivered.show && (
          <TableCell className="material-table__row__cell text-right px-4 text-[--secondaryText] font-bold">
            {seqContact.delivered_count}
          </TableCell>
        )}
        {fieldsToShow.opens.show && (
          <TableCell className="material-table__row__cell text-right px-4 text-[--frenchPink] font-bold">
            {seqContact.opens_count}
          </TableCell>
        )}
        {fieldsToShow.replies.show && (
          <TableCell className="material-table__row__cell text-right px-4 text-[--primary1000] font-bold">
            {seqContact.replies_count}
          </TableCell>
        )}
        {fieldsToShow.contactSubject.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.contact_subject}
          </TableCell>
        )}
        {fieldsToShow.outletType.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.outlet_type}
          </TableCell>
        )}
        {fieldsToShow.uvpm.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.unique_monthly_visitors}
          </TableCell>
        )}
        {fieldsToShow.audience.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.audience}
          </TableCell>
        )}
        {fieldsToShow.da.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.domain_authority}
          </TableCell>
        )}
        {fieldsToShow.country.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.country}
          </TableCell>
        )}
        {fieldsToShow.dma.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.dma}
          </TableCell>
        )}
        {/* {fieldsToShow.keyword.show && (
          <TableCell className="material-table__row__cell">
            keyword
          </TableCell>
        )}
        {fieldsToShow.other.show && (
          <TableCell className="material-table__row__cell">
            other
          </TableCell>
        )}
        {fieldsToShow.custom1.show && (
          <TableCell className="material-table__row__cell">
            custom
          </TableCell>
        )}
        {fieldsToShow.custom2.show && (
          <TableCell className="material-table__row__cell">
            custom
          </TableCell>
        )}
        {fieldsToShow.custom3.show && (
          <TableCell className="material-table__row__cell">
            custom
          </TableCell>
        )}
        {fieldsToShow.competitor.show && (
          <TableCell className="material-table__row__cell">
            competitor
          </TableCell>
        )} */}
        <TableCell className="material-table__row__cell dots-actions text-right">
          <Can I="edit" a="Sequence Contact">
            {this.renderPopoverActions(seqContact)}
          </Can>
        </TableCell>
      </TableRow>
    );
  }
}

ContactRow.contextType = AbilityContext;

ContactRow.propTypes = {
  seqContact: PropTypes.shape({}).isRequired,
  isSelected: PropTypes.bool.isRequired,
  parentComponentId: PropTypes.string.isRequired,
  handleSelectClick: PropTypes.func.isRequired,
  showErrors: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  toggleContactEditModal: PropTypes.func.isRequired,
  fieldsToShow: PropTypes.shape({}).isRequired,
  showContactReplyForCurrentSequence: PropTypes.bool,
};

ContactRow.defaultProps = {
  showErrors: true,
  showContactReplyForCurrentSequence: false,
};

export default ContactRow;
